import { Show } from "solid-js";
import Text from "../../text/Text";
import type { DynamicValueOption } from "../../../types/Menu";
import { DynamicValueIconTile } from "../../icon/IconTile";

const DynamicValueSelectValue = (props: Omit<DynamicValueOption<null>, "value">) => (
  <div class="group flex min-w-0 items-center gap-x-1.5 select-none">
    <Show when={props.icon}>
      {(icon) => <DynamicValueIconTile icon={icon().name} size="sm" iconClassList={{ [icon().class]: true }} />}
    </Show>
    <Text as="span" truncate text={props.label} class="text-base-medium text-primary group-disabled:text-disabled" />
  </div>
);

export default DynamicValueSelectValue;
